"use strict";
/*
 * Created on 13. 2. 2019
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * Request for getting PriceChangeReport.
 * @author SKu
 */


var PriceChangeReportRequest =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(PriceChangeReportRequest, _DomainObject_1$Domai);

  /**
   * Dates when FinalPrice has been changed
   * @param dateFrom
   * @param dateTo
   * @param categoryId
   * @param productIds
   */
  function PriceChangeReportRequest(dateFrom, dateTo, categoryId, productIds) {
    var _this;

    _classCallCheck(this, PriceChangeReportRequest);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PriceChangeReportRequest).call(this));
    _this.dateFrom = dateFrom;
    _this.dateTo = dateTo;
    _this.categoryId = categoryId;
    _this.productIds = productIds;
    return _this;
  }

  return PriceChangeReportRequest;
}(DomainObject_1.DomainObject);

exports.PriceChangeReportRequest = PriceChangeReportRequest;

PriceChangeReportRequest.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(PriceChangeReportRequest.name);
  return {
    dateFrom: builder.date('dateFrom', DateParser_1.DateParser.ISO_PATTERN),
    dateTo: builder.date('dateTo', DateParser_1.DateParser.ISO_PATTERN),
    categoryId: builder.str('categoryId'),
    productIds: builder.listOf(builder.str('productIds'))
  };
}();